// extracted by mini-css-extract-plugin
export default {"header-container":"FormLeads_header-container__+DL92","select-type":"FormLeads_select-type__b29d4","select-input":"FormLeads_select-input__zGhmW"};